import { createSlice } from '@reduxjs/toolkit';
import { initStateUserLogin, reducerUserLogin } from '../actions/user/userLogin';
import { initStateUserMe, reducerUserMe } from '../actions/user/userMe';
import { initStateUserGeneratePassword, reducerUserGeneratePassword } from '../actions/user/userGeneratePassword';
import { initStateUserRegistration, reducerUserRegistration } from '../actions/user/userRegistration';
import { initStateUserResetPassword, reducerUserResetPassword } from '../actions/user/userResetPassword';
import { initStateUserFindTransaction, reducerUserFindTransaction } from '../actions/user/userFindTransaction';
import { initStateUserChangeTransaction, reducerUserChangeTransaction } from '../actions/user/userChangeTransaction';
import { initStateUserDashboard, reducerUserDashboard } from '../actions/user/userDashboard';
import { initStatePartnerDashboard, reducerPartnerDashboard } from '../actions/user/partnerDashboard';
import { initStateUserTransactionHistory, reducerUserTransactionHistory } from '../actions/user/userTransactionHistory';

export const initialState = {
  ...initStateUserLogin,
  ...initStateUserMe,
  ...initStateUserGeneratePassword,
  ...initStateUserRegistration,
  ...initStateUserResetPassword,
  ...initStateUserFindTransaction,
  ...initStateUserChangeTransaction,
  ...initStateUserDashboard,
  ...initStatePartnerDashboard,
  ...initStateUserTransactionHistory,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUserLogin(state, action) {
      state.userLogin = initStateUserLogin.userLogin;
    },
    resetUserMe(state, action) {
      state.userMe = initStateUserMe.userMe;
    },
    resetUserGeneratePassword(state, action) {
      state.userGeneratePassword = initStateUserGeneratePassword.userGeneratePassword;
    },
    resetUserRegistration(state, action) {
      state.userRegistration = initStateUserRegistration.userRegistration;
    },
    resetUserResetPassword(state, action) {
      state.userResetPassword = initStateUserResetPassword.userResetPassword;
    },
  },
  extraReducers: {
    ...reducerUserLogin,
    ...reducerUserMe,
    ...reducerUserGeneratePassword,
    ...reducerUserRegistration,
    ...reducerUserResetPassword,
    ...reducerUserFindTransaction,
    ...reducerUserChangeTransaction,
    ...reducerUserDashboard,
    ...reducerPartnerDashboard,
    ...reducerUserTransactionHistory,
  },
});
export const { resetUserResetPassword, resetUserRegistration, resetUserGeneratePassword, resetUserMe, resetUserLogin } = userSlice.actions;
export const userReducer = userSlice.reducer;
